import { render } from "./UnvalidLead.vue?vue&type=template&id=1a5aed76"
import script from "./UnvalidLead.vue?vue&type=script&lang=js"
export * from "./UnvalidLead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__